export class CheatConstants {

    public static readonly BUTTON_MENU: number = 67;
    public static readonly BUTTON_RESET: number = 82;
    public static readonly PAGES: string[] = [
        'info',
        'AMDemo',
        'filters',
        'matrix',
        'reelsetMatrix',
        'history',
        'sessions',
        'errorsPopup',
        'sounds'
    ];

    public static readonly WIN_TYPES: string[] = [
        'WinType1',
        'WinType2',
        'WinType3',
        'WinType4',
        'WinType5',
        'WinType6',
        'BigWinX20',
        'BigWinX50',
        'BigWinX100'
    ];

    public static readonly MOVING_DISTANCE: number = 100;
}